import NewVehicleObject from "../../finance/vehicle-objects/new-vehicle-object";

export default class extends NewVehicleObject {
    constructor(target) {
        super(target);
    }

    getCodeweaversRequestObject(financeKeyObject) {
        let imgEl = document.querySelector('.exterior-image img[data-index="0"]');
        let image = (imgEl) ? imgEl.getAttribute('src') : '';
        return {
            "Id": this.id,
            "Vehicle":{
                "CashPrice": this.getPriceForFinanceKeyObject(financeKeyObject),
                "RegistrationDate": this.registrationDate,
                "IsNew": true,
                "Identifier": this.identifier,
                "IdentifierType": this.identifierType,
                "Type": this.carOrLCV,
                "ImageUrl": image,
                "DealerVehicleUrl": window.location.href,
            },
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/vehicle-object.js